import { render, staticRenderFns } from "./BillHeaderBlock.vue?vue&type=template&id=6aa08423&scoped=true"
import script from "./BillHeaderBlock.vue?vue&type=script&lang=js"
export * from "./BillHeaderBlock.vue?vue&type=script&lang=js"
import style0 from "./BillHeaderBlock.vue?vue&type=style&index=0&id=6aa08423&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa08423",
  null
  
)

export default component.exports